export default {
    login: {
        url: 'auth/login',
        method: 'post'
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/api/global/index.ts
// module id = null
// module chunks = 